import useSWRMutation from 'swr/mutation'
import {decamelizeKeys} from 'humps'
import {fetcher} from '../../../api/fetcher'
import {useRails} from '../../contexts/rails'

// Submits the manually entered payout account details as a support request.
// Deferred until the supplier has completed the reconciliation account step, so
// nothing is recorded (and the onboarding step never shows "in progress") until
// they finish the flow.
const useSubmitPayoutAccountSupportRequest = () => {
  const {
    organisation: {currentSupplier},
    authenticityToken,
  } = useRails()

  const {trigger, isMutating} = useSWRMutation(
    `/api/suppliers/${currentSupplier.id}/banking_aggregators/payout_account_connection_support_requests`,
    async (url, {arg}) => {
      const decamelized = decamelizeKeys({
        bank: arg.bank,
        accountType: arg.accountType?.value ?? arg.accountType,
        accountName: arg.accountName,
        bsb: arg.bsb.replace('-', ''),
        accountNumber: arg.accountNumber,
      })

      const formData = new FormData()
      Object.entries(decamelized).forEach(([key, value]) =>
        formData.append(`support_request[${key}]`, value),
      )
      if (arg.statementFile) {
        formData.append('support_request[bank_statement]', arg.statementFile)
      }

      return fetcher(url, {
        method: 'POST',
        headers: {'X-CSRF-Token': authenticityToken},
        body: formData,
      })
    },
    // This is a fire-and-forget command with nothing subscribed to the key, so
    // there is no cached resource to revalidate after submitting.
    {revalidate: false, populateCache: false},
  )

  return {submit: trigger, isSubmitting: isMutating}
}

export default useSubmitPayoutAccountSupportRequest
